<script>

import {forEach} from 'lodash';

export default {
  render: function(createElement) {
    return createElement(
      'div',
      {
        class: 'popover-content'
      },
      [
        createElement('v-popover', {
          attrs: this.$attrs,
          props: {
            container: '.popover-content'
          },
          scopedSlots: this.getSlots(createElement),
          on: this.$listeners
        }),
        createElement('div', {
          class: 'popover-backdrop'
        })
      ]
    );
  },
  mounted() {
    document.addEventListener('keyup', this.escapeKeyListener);
  },
  destroyed() {
    document.removeEventListener('keyup', this.escapeKeyListener);
  },
  methods: {
    getSlots(createElement) {
      let slots = {};

      forEach(this.$slots, (slot, key) => {
        slots[key] = () => slot;
      });

      return slots;
    },
    changeIsOpen(isOpen) {
      this.isOpen = isOpen;
    },
    escapeKeyListener(e) {
      if (e.keyCode === 27) {
        this.changeIsOpen(false);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '~VariablesStyles';

@media (max-width: $tablet) {
  /deep/ .tooltip-inner {
    box-shadow: none;
  }
}
</style>
